/**
 * Navigation utilities for smooth scrolling and section management
 */

/**
 * Smoothly scrolls to a section by ID
 * @param {string} sectionId - The ID of the section to scroll to
 */
export const navigateToSection = (sectionId) => {
  console.log('Navigating to section:', sectionId);
  const section = document.getElementById(sectionId);
  if (section) {
    console.log('Section found, scrolling to:', section);
    // Try different scroll options for better mobile compatibility
    section.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  } else {
    console.warn('Section not found:', sectionId);
  }
};

/**
 * Navigates to stock section and selects a specific game
 * @param {string} gameName - Name of the game to select
 * @param {number} currentGameIndex - Current game index
 * @param {Function} setCurrentGameIndex - State setter for game index
 * @param {Function} setHasSelectedGame - State setter for selection status
 */
export const navigateToStockFor = (
  gameName,
  currentGameIndex,
  setCurrentGameIndex,
  setHasSelectedGame,
) => {
  const gameIndex = currentGameIndex; // Default to current game index
  if (gameIndex !== -1) {
    // If found, set the current game index and stop auto-rotation
    setCurrentGameIndex(gameIndex);
    setHasSelectedGame(true);

    // Scroll to the stock section
    const stockSection = document.getElementById('stock');
    if (stockSection) {
      stockSection.scrollIntoView({ behavior: 'smooth' });

      const stockSelector = document.getElementById('stock-selector');
      if (!stockSelector) return;

      // Get the stock item with text content matching the game name
      const items = Array.from(
        stockSelector.querySelectorAll('.game-stock-select'),
      );

      const stockItem = items.find(
        (el) =>
          el.textContent.includes(gameName) ||
          el.getAttribute('key')?.includes(gameName),
      );

      if (stockItem) {
        stockItem.click();
      }
    }
  } else {
    console.warn(`Game "${gameName}" not found in the list.`);
  }
};
